import React from "react";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";

const DateTimePickerWrapper = ({ value, onChange, ...props }) => {
  return <DateTimePicker value={value} onChange={onChange} {...props} />;
};

export default DateTimePickerWrapper;
